/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'project-panel.generic-error.description': 'Kontrollér din internetforbindelse, og prøv igen.',
  'project-panel.generic-error.title': 'Noget gik galt',
  'project-panel.project-icon-header.update-error-description': 'Ikonet for {projectName} kunne ikke opdateres',
  'project-panel.project-icon-header.update-error-title': 'Noget gik galt.',
  'project-panel.project-panel-expand-field-button.show-less-collapsed-label': 'Vis flere felter',
  'project-panel.project-panel-expand-field-button.show-more-collapsed-label': 'Vis mindre',
  'project-panel.project-panel-header.title': 'Projekt',
  'project-panel.project-panel-tabs.about-tab-title': 'Om',
  'project-panel.project-panel-tabs.decisions-title': 'Beslutninger',
  'project-panel.project-panel-tabs.learnings-title': 'Læring',
  'project-panel.project-panel-tabs.risks-title': 'Risici',
  'project-panel.project-panel-tabs.updates-tab-title': 'Opdateringer',
  'project-panel.project-title.edit-button-label': 'Rediger projekttitlen',
  'project-panel.project-title.update-error-description': 'Kunne ikke opdatere indholdet for {projectName}',
  'project-panel.project-title.update-error-title': 'Noget gik galt',
  'project-panel.project-title.validation-message': 'Angiv en titel til dit projekt',
};
